import type { ReactNode } from 'react';

// Hinweis an den Stellen, an denen die KI ein Dokument liest: wohin es geht. Im Testbetrieb (die KI läuft nicht nur
// in der EU) steht dort stattdessen, dass nur Testdaten hochgeladen werden dürfen.
export function KiHinweis({ test, children }: { test: boolean; children?: ReactNode }) {
  if (test) {
    return (
      <p className="note ki-test" role="note">
        Testbetrieb: Die KI läuft gerade nicht nur in der EU. Bitte nur Testdaten hochladen, keine echten Mandantendaten.
      </p>
    );
  }
  return <p className="note">{children ?? 'Die KI (über Google Cloud, Rechenzentren in der EU) liest das Dokument.'}</p>;
}
